import requestCommon from "@/components/web-interface/requestCommon";
const state = {
    holidayDetails: null,
    upcomingHolidayData: null,
};
const actions = {
    getHolidayDetails(context, data) {
        return requestCommon.getInfo(
            "/holidays?" + "month=" + data.month + "&year=" + data.year,
            data,
            null,
            context,
            "getHolidayDetailsSuccessHandler",
            "getHolidayDetailsErrorHandler"
        );
    },
    getUpcomingHoliday(context, data) {
        return requestCommon.getInfo(
            "/holidays/upComing",
            null,
            null,
            context,
            "getUpcomingHolidayDataSuccessHandler",
            "getUpcomingHolidayDataErrorHandler"
        );
    },
}
const mutations = {
    getHolidayDetailsSuccessHandler(state, data) {
        state.holidayDetails = data.server.data;
    },
    getHolidayDetailsErrorHandler(context, error) {
        console.log(error);
    },
    getUpcomingHolidayDataSuccessHandler(state, data) {
        state.holidayData = data.server.data;
    },
    getUpcomingHolidayDataErrorHandler(context, error,) {
        console.log(error);
    },
};
const getters = {};
export const holidayStore = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}